import { Box, CircularProgress } from "@mui/material"
import { SearchOutlined } from "@mui-symbols-material/w300"
import React, { useState } from "react"
import type { FC } from "react"
import { useFormContext } from "react-hook-form"

import { FilterCheckbox } from "@/components/common/Filters"
import { InputField } from "@/components/common/InputField"
import { DEBOUNCE_DELAY_MS } from "@/constants/common"
import type { ClassificationQueryableFields } from "@/graphql/codegen/graphql"
import useProductManager from "@/hooks/api/useProductManager"
import useDebounce from "@/utils/useDebounce"

interface ProductManagerProps {
  onFilterChange: (name: keyof ClassificationQueryableFields, value: any) => void
}

export const ProductManagerFilter: FC<ProductManagerProps> = ({ onFilterChange }) => {
  const [searchTerm, setSearchTerm] = useState("")
  const { control, watch } = useFormContext()
  const productManagersValue = watch("productManagerIds") || []
  const debouncedSearchString = useDebounce(searchTerm, DEBOUNCE_DELAY_MS)

  const { productManagerList, fetching } = useProductManager({ query: debouncedSearchString })

  const handleFilterChange = (newValue: string[]) => {
    onFilterChange("productManagerIds", newValue)
  }

  return (
    <>
      <Box className='flex-none p-4'>
        <InputField
          placeholder='Search by Name'
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          startAdornment={<SearchOutlined className='text-gray-600' />}
          endAdornment={fetching && <CircularProgress size={20} />}
        />
      </Box>

      <Box className='flex-1 overflow-y-auto overflow-x-hidden px-8'>
        {productManagerList.map((manager) => (
          <FilterCheckbox
            key={manager.userId}
            label={manager.name}
            value={manager.userId}
            control={control}
            name='productManagerIds'
            values={productManagersValue}
            onFilterChange={handleFilterChange}
          />
        ))}

        {fetching && (
          <Box display='flex' justifyContent='center' py={2}>
            <CircularProgress size={24} />
          </Box>
        )}
      </Box>
    </>
  )
}
